import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import SearchResultsContent from '../../components/Pages/SearchResults';

const { displayName } = config;

export default function SearchResults(): React.ReactNode | null {
  document.title = `${displayName}: SearchResults`;

  return (
    // disableLeftMenu={user && user.role ? user?.role === UserRoles.APPLICANT : true}
    // leftMenu={<LeftMenu />}
    <Layout>
      <SearchResultsContent />
    </Layout>
  );
}
